import React, { Suspense, useContext, useState } from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";

import { Loading } from "components";
import { AuthLayout } from "containers";

import {
  AuthContext,
  AuthorizationStage,
} from "providers/AuthProvider/context/AuthContext";
import { CompleteResetPassword } from "./ResetPassword/CompleteResetPassword/CompleteResetPassword";
import { ResetPasswordInitial } from "./ResetPassword/ResetPasswordInitial";

const Login = React.lazy(() => import("views/auth/Login"));
const RegistrationInitial = React.lazy(() => import("views/auth/Registration"));
const RegistrationNext = React.lazy(() => import("views/auth/Registration/RegistrationNext"));
const CompleteRegistration = React.lazy(() => import("views/auth/Registration/CompleteRegistration"));

export function AuthRoutes() {
  const { authorizationStage } = useContext(AuthContext);
  const [resetPassData, setResetPassData] = useState({
    email: "",
    reset_code: "",
  });

  // Needed to build redirect path with current locale
  const { lang } = useParams();
  const prefix = lang ? `/${lang}` : "";

  const isAuthorized = authorizationStage === AuthorizationStage?.AUTHORIZED;

  const authRouteTree = (
    <Route
      element={
        isAuthorized ? (
          <Navigate to={`${prefix}/pr-visit-doctor/current`} replace />
        ) : (
          <AuthLayout />
        )
      }
    >
      <Route path="login" element={<Login />} />
      <Route path="registration" element={<RegistrationInitial />} />
      <Route path="registration-initial-next" element={<RegistrationNext />} />
      <Route path="registration-initial-complete" element={<CompleteRegistration />} />
      <Route
        path="reset-password"
        element={<ResetPasswordInitial saveData={setResetPassData} />}
      />
      <Route
        path="complete-reset-password-initial"
        element={<CompleteResetPassword data={resetPassData} />}
      />
    </Route>
  );

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Georgian (no prefix) */}
        <Route path="/">{authRouteTree}</Route>

        {/* Other locales (e.g. /en, /ru) */}
        <Route path="/:lang">{authRouteTree}</Route>
      </Routes>
    </Suspense>
  );
}
